import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ModalComponent} from '../../../centrui/src/app/components/modal/modal.component';
import {ModalService} from '../../../centrui/src/app/services/modal.service';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {PromptUpdateService} from '../../../services/prompt-update.service';
import {CentruiButtonComponent} from "../../../centrui/src/app/components/centrui-button/centrui-button.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-new-version-available',
  templateUrl: './new-version-available.component.html',
  styleUrls: ['./new-version-available.component.scss'],
  imports: [
    CentruiButtonComponent,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class NewVersionAvailableComponent extends ModalComponent implements OnInit {
  @Input() version!: string;
  @Input() preventReload!: boolean;
  constructor(
    public override modalService: ModalService,
    public override ngxSmartModalService: NgxSmartModalService,
    private promptUpdateService: PromptUpdateService
  ) {
    super(modalService, ngxSmartModalService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override close(result: any) {
    if (this.preventReload) {
      super.close(result);
    } else {
      this.promptUpdateService.clearCacheStorage().then(() => {
        window.location.reload();
      });
    }
  }

}
